"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = exports.Mute = void 0;
var Mute;
(function (Mute) {
    Mute["MUTED"] = "muted";
    Mute["UN_MUTED"] = "un-muted";
})(Mute = exports.Mute || (exports.Mute = {}));
var Device;
(function (Device) {
    Device["MOBILE"] = "mobile";
    Device["DESKTOP"] = "desktop";
})(Device = exports.Device || (exports.Device = {}));
//# sourceMappingURL=APIOptions.js.map